import { Status } from 'src/graphql/types';

export const calculateStatusCounts = <T extends { status: Status }>(
  objectsWithStatus: T[]
) =>
  objectsWithStatus.reduce(
    (acc, { status }) => {
      return {
        ...acc,
        [status || 'UNKNOWN']: acc[status || 'UNKNOWN'] + 1,
      };
    },
    {
      RECEIVED: 0,
      PROCESSED: 0,
      PART_SHIPPED: 0,
      SHIPPED: 0,
      PART_DELIVERED: 0,
      DELIVERED: 0,
      PART_INVOICED: 0,
      INVOICED: 0,
      UNKNOWN: 0,
      REJECTED: 0,
      POTENTIAL: 0,
    }
  );
